import { useTranslation } from '@fareye/common'
import { Flex, layout, styled, PopOver, Label } from '@fareye/ui'
import { getValueFromNestedKey } from '@fareye/utils'
import React from 'react'
import { Link, Span } from '../../../components/Timeline/styled'
import { formatters } from '../../../config/constants'
import { IColumn } from '../../../utility/types'

interface IHeader {
  align?: 'left' | 'right' | 'center'
}

const ColFullHeight = styled((props: any) => (
  <Flex
    p={1}
    justifyContentSpaceEvenly
    column
    {...props}
    style={{
      width: '100%',
      height: '100%',
      padding: '2px 4px',
      ...props.style,
      boxSizing: 'content-box'
    }}
  >
    {props.children}
  </Flex>
))`
  ${layout}
`
const Header: any = styled(Span)`
  width: 100%;
  display: block;
  text-transform: uppercase;
  padding: 0 3px;
  text-align: ${({ align = 'left' }: IHeader) => align};
`
function generateColumnObject(
  column: IColumn,
  { t, links, queryParams = {} }: any
) {
  const { label, key, formatter, columnConfig } = column
  switch (key) {
    case 'packageIdList':
      return {
        Header: () => (
          <Header variant={'h2'} data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 140,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight>
            <Span variant="ellipsis">
              <Link
                target="_blank"
                variant="xs"
                title={original.shipmentNo}
                to={`${links.tripShare}/${
                  original.shipmentNo
                }${queryParams.tripShare || ''}`}
              >
                {original.shipmentNo}
              </Link>
            </Span>
          </ColFullHeight>
        )
      }
    case 'vendorStatus':
      return {
        Header: () => (
          <Header variant={'h2'} data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 140,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => {
          let value = getValueFromNestedKey(original, key)
          return (
            <ColFullHeight>
              <Span variant="ellipsis">
                {value ? value.replace(/_/g, ' ') : '-'}
              </Span>
            </ColFullHeight>
          )
        }
      }
    default:
      return {
        Header: () => (
          <Header variant={'h2'} data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 140,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => {
          let value = getValueFromNestedKey(original, key)
          return (
            <ColFullHeight>
              <Span variant="ellipsis">
                {formatter && formatters[formatter]
                  ? formatters[formatter](value) || '-'
                  : value ?? '-'}
              </Span>
            </ColFullHeight>
          )
        }
      }
  }
}
export function getTableColumns(
  reqdColumns: IColumn[],
  { t, links, queryParams = {} }: any
) {
  const result: any = []
  reqdColumns.map(ele => {
    if (ele.key) {
      result.push(generateColumnObject(ele, { t, links, queryParams }))
    }
  })
  return result
}
